import { memo } from "react";
import { Button } from "react-bootstrap";
import styled from "styled-components";

type Props = {
  isLocked: boolean;
  onClick: () => void;
};

const ReportLockButton = memo((props: Props) => {
  const { isLocked, onClick } = props;

  const getTooltip = () => {
    if (isLocked) {
      return "レポートロック中";
    }
    return "ロックする";
  };

  const getStyle = () => {
    if (isLocked) return "locked";
    return "";
  };

  return (
    <div title={getTooltip()}>
      <SButton size="sm" className={`${getStyle()} btn btn-info`} onClick={onClick}>
        {isLocked ? (
          <>
            <i className="fas fa-lock" />
          </>
        ) : (
          <i className="fas fa-lock-open" />
        )}
      </SButton>
    </div>
  );
});

export default ReportLockButton;

const SButton = styled(Button)`
  background-image: none;
  background-color: transparent;
  color: ${(props) => props.theme.color.lockNone};
  border: none;
  width: 45px;
  font-size: 20px;
  :hover {
    color: ${(props) => props.theme.color.lockNoneHover};
    background: none !important;
    border: none !important;
  }
  :focus {
    background-color: transparent !important;
    color: ${(props) => props.theme.color.lockNone} !important;
  }
  &.locked {
    color: ${(props) => props.theme.color.lockReport} !important;
    &.btn-info:hover,
    .btn-info:focus {
      background-image: none;
      background: none;
      border: none;
      color: ${(props) => props.theme.color.lockReportHover} !important;
    }
  }
`;
